import { toBooleanFromBit } from './productCategoryHelpers';

export const mapProductCategoryFromApi = (row) => {
  if (!row) return null;
  return {
    CategoryId: row.CategoryId ?? null,
    CategoryName: row.CategoryName || '',
    Slug: row.Slug || '',
    ImageUrl: row.ImageUrl || '',
    DisplayOrder: row.DisplayOrder ?? 0,
    IsActive: toBooleanFromBit(row.IsActive, true),
  };
};

export const buildProductCategorySavePayload = (data, userId) => ({
  CategoryId: data.CategoryId || null,
  CategoryName: data.CategoryName?.trim() || '',
  Slug: data.Slug?.trim() || '',
  ImageUrl: data.ImageUrl?.trim() || null,
  DisplayOrder: data.DisplayOrder ?? 0,
  IsActive: data.IsActive !== false && data.IsActive !== 0 ? 1 : 0,
  UserId: userId,
});
